import { OrmModel, StringField, BelongsToField, AttrField, BooleanField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import UserPersonalInfo from '@/data/models/domain/UserPersonalInfo'
import RecipientContact from '@/data/models/domain/RecipientContact'
import AutomationLogPreview from '@/data/models/domain/automations/automationLogPreview'
import AutomationLogStep from '@/data/models/domain/automations/automationLogStep'
import type {
  AutomationStepType,
  AutomationFlowStepPayload,
  AutomationLogStatus,
  AutomationLogEntityRecord,
  AutomationLogDetailsRecord,
} from '@/data/models/domain/automations/types'
import { transformAutomationFlowStepPayload } from '@/data/models/domain/automations/automationFlowStepPayloadTransformer'
import type { Nullable } from '@/types'

@OrmModel(modelNames.AUTOMATION_LOG)
export default class AutomationLog<
  T extends AutomationStepType = AutomationStepType,
  R extends AutomationLogStatus = AutomationLogStatus,
> extends BaseModel {
  @StringField()
  public automationId: string

  @BelongsToField(AutomationLogPreview, 'automationId')
  public automation: AutomationLogPreview

  @StringField()
  public contactId: string

  @BelongsToField(RecipientContact, 'contactId')
  public contact: RecipientContact

  @StringField()
  public stepId: string

  @BelongsToField(AutomationLogStep, 'stepId')
  public step: AutomationLogStep<T>

  @StringField()
  public userId: string

  @BelongsToField(UserPersonalInfo, 'userId')
  public user: UserPersonalInfo

  @StringField()
  public status: R

  @AttrField()
  public reason: string | null

  @BooleanField(false)
  public isRetryable: boolean

  @AttrField()
  public entity: Nullable<AutomationLogEntityRecord[T]>

  @StringField()
  public createdAt: string

  @StringField()
  public finishedAt: R extends AutomationLogStatus.Success ? string : null

  @AttrField(null, transformAutomationFlowStepPayload)
  public payload: AutomationFlowStepPayload<T>

  @AttrField()
  public details: Nullable<AutomationLogDetailsRecord[T]>

  @BooleanField(false)
  public jumped: boolean

  @AttrField(null)
  public jumpedFromStepLocalId: Nullable<number>
}
